import { gql } from "graphql-request";


const USER_PROPS_FRAGMENT = gql`
    fragment UserPropsFragment on User {
        id
        email
        username
        primaryOrg {
            id
            name  
            stripeAccountStatus          
        }
        subscription{
            plan
        }
        # memberships {
        #     id
        #     organization {
        #         id
        #         name
        #     }
        # }

    }
`;

export const GET_USER_BY_ID_QUERY = gql`
    query getUserById($id: FirstLevelIDInput!, $context: RequestContextInput!) {
        getUser(id: $id, context: $context) {
            ...UserPropsFragment
        }
    }
    ${USER_PROPS_FRAGMENT}
`;

export const GET_ORGANIZATION_BY_ID_QUERY = gql`
    query getOrgById($id: FirstLevelIDInput!, $context: RequestContextInput!) {
        getOrganization(id: $id, context: $context) {
            id
            name
            organizationOwnerId
        }
    }    
`;

export const GET_ORGANIZATION_STAT_BY_ID_QUERY = gql`
    query getOrgStatById($id: FirstLevelIDInput!, $context: RequestContextInput!) {
        getOrganizationStat(id: $id, context: $context) {
            publicTemplatesCount
            privateTemplatesCount
            publicModelersCount
            privateModelersCount
            publicStorageSize
            privateStorageSize
            totalDeposits
            totalCharges
        }
    }
`;

export const GET_DEPOSITS_BY_ORGANIZATION_QUERY = gql`
    query listOrganizationDeposits($filter: FirstLevelFilterInput!, $size: Int, $nextToken: String, $context: RequestContextInput!) {
        listOrganizationDeposits(filter: $filter, size: $size, nextToken: $nextToken, context: $context) {
            items {
                id
                transactionType
                transactionSource
                description
                createdAt
                description
                amount
                currency
            }
            nextToken
        }
    }
`;


export const UPDATE_ORGANIZATION_MUTATION = gql`
    mutation updateOrganization($input: UpdateOrganizationInput!, $condition: FirstLevelIDInput!,$context: RequestContextInput!) {
        updateOrganization(input: $input, condition: $condition , context: $context) {
            name
        }
    }
`;

export const GET_ORGANIZATION_SUBSCRIPTION_QUERY = gql`
    query getOrganizationSubscriptions($id: FirstLevelIDInput!, $context: RequestContextInput!) {
        getOrganizationSubscription(id: $id, context: $context) {
            id
            plan
            canceled,
            cancelAt
        }
    }
`;